import models from '@/nebula/models';
import schema from '@/nebula/schema';
import useFacets from '@/nebula/facets';
import { denormalize } from 'normalizr';
import { facetConfig } from '@/nebula/facet-config';
import { references } from '@/nebula/references';

const getters = {};

const { applyFacets } = useFacets(references, facetConfig);

models.forEach((model) => {
  getters[`${model}Map`] = (state) => Object.keys(state[model]).reduce((res, next) => {
    res[next] = applyFacets(denormalize(next, schema[model], state), model);
    return res;
  }, {});
  getters[model] = (_, getters) => Object.values(getters[`${model}Map`]);
});

export default getters;
